module.exports = __webpack_public_path__ + "static/media/nz.6ef79213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nz.png
// module id = 1949
// module chunks = 0